import { z } from 'zod'

/**
 * CA cancel-reason used after a shipment already exists (WEBLP-2507).
 * Web has no reason picker yet, so this matches the verified CA payload.
 */
export const SHIPMENT_CANCEL_REASON_ID = 'EDSHAP'
export const SHIPMENT_CANCEL_NOTE = 'Edit shipment setelah bayar'

export const cancelShipmentsRequestSchema = z.object({
  shipment_ids: z.array(z.string().trim().min(1)).min(1),
  reason_id: z.string().trim().min(1),
  note: z.string().trim().min(1),
})

export const cancelShipmentsResponseSchema = z.unknown()

export type CancelShipmentsRequest = z.infer<typeof cancelShipmentsRequestSchema>
